(function(){
  if (window.__danteBIS) return;
  window.__danteBIS = true;
  var REV = '2024-10-15';

  var css = ''
    + 'dante-bis.dante-bis{display:block;margin-top:10px}'
    + '.dante-bis__trigger{display:inline-flex;align-items:center;justify-content:center;gap:6px;width:100%;padding:12px 16px;border:1px solid currentColor;border-radius:6px;background:transparent;color:inherit;font-weight:600;font-size:14px;line-height:1.2;cursor:pointer}'
    + '.dante-bis__trigger:hover{opacity:.8}'
    + '.dante-bis__panel{margin-top:10px;padding:12px;border:1px solid #e5e5e5;border-radius:8px;background:#fafafa}'
    + '.dante-bis__hint{margin:0 0 8px;font-size:13px;opacity:.85}'
    + '.dante-bis__row{display:flex;gap:8px}'
    + '.dante-bis__email{flex:1;min-width:0;padding:10px 12px;border:1px solid #cfcfcf;border-radius:6px;font-size:14px;color:#111;background:#fff}'
    + '.dante-bis__submit{padding:10px 16px;border:0;border-radius:6px;background:#111;color:#fff;font-weight:600;font-size:14px;white-space:nowrap;cursor:pointer}'
    + '.dante-bis__submit:disabled{opacity:.6;cursor:default}'
    + '.dante-bis__msg{margin:8px 0 0;font-size:13px}'
    + '.dante-bis__msg[data-ok="1"]{color:#1a7f37}'
    + '.dante-bis__msg[data-ok="0"]{color:#c0392b}'
    + '@media (max-width:480px){.dante-bis__row{flex-direction:column}}';
  try { var st = document.createElement('style'); st.textContent = css; (document.head||document.documentElement).appendChild(st); } catch(e){}

  function parseVariants(el){
    if (el._bisV) return el._bisV;
    try { var s = el.querySelector('.dante-bis-data'); el._bisV = s ? JSON.parse(s.textContent) : []; }
    catch(e){ el._bisV = []; }
    return el._bisV;
  }
  function inSet(v, id){ for (var i=0;i<v.length;i++){ if (String(v[i].id)===String(id)) return v[i]; } return null; }
  function currentVariant(el){
    var v = parseVariants(el);
    var u = null;
    try { u = new URL(window.location.href).searchParams.get('variant'); } catch(e){}
    if (u && inSet(v,u)) return u;
    return el.getAttribute('data-selected');
  }
  function formOf(el){ var id = el.getAttribute('data-form'); return id ? document.getElementById(id) : null; }
  function isSoldOut(el){
    var f = formOf(el); if (!f) return false;
    var btn = f.querySelector('.hdt-product-form__submit'); if (!btn) return false;
    var label = btn.querySelector('.hdt-btn-atc_text');
    var txt = ((label ? label.textContent : btn.textContent) || '').trim().toLowerCase();
    var want = (el.getAttribute('data-soldout-text') || '').trim().toLowerCase();
    return !!btn.disabled && txt === want && want !== '';
  }
  function evalEl(el){
    var trigger = el.querySelector('.dante-bis__trigger'); if (!trigger) return;
    var panel = el.querySelector('.dante-bis__panel');
    if (isSoldOut(el)){
      var vid = currentVariant(el);
      if (el.getAttribute('data-variant') !== vid){
        el.setAttribute('data-variant', vid);
        if (el.getAttribute('data-open') === '1'){ reset(el); }
      }
      if (el.getAttribute('data-open') !== '1'){ trigger.hidden = false; }
    } else {
      trigger.hidden = true;
      if (panel) panel.hidden = true;
      el.removeAttribute('data-open');
      reset(el);
    }
  }
  function reset(el){
    var panel = el.querySelector('.dante-bis__panel'); if (!panel) return;
    panel.hidden = true;
    var row = panel.querySelector('.dante-bis__row'); if (row) row.hidden = false;
    var hint = panel.querySelector('.dante-bis__hint'); if (hint) hint.hidden = false;
    var msg = panel.querySelector('.dante-bis__msg'); if (msg){ msg.hidden = true; msg.textContent=''; }
    var sb = panel.querySelector('.dante-bis__submit'); if (sb){ sb.disabled=false; sb.textContent='Avisarme'; }
  }
  function evalAll(){ var els = document.querySelectorAll('dante-bis.dante-bis'); for (var i=0;i<els.length;i++) evalEl(els[i]); }
  function openPanel(el){
    var trigger = el.querySelector('.dante-bis__trigger');
    var panel = el.querySelector('.dante-bis__panel');
    el.setAttribute('data-open','1');
    if (trigger) trigger.hidden = true;
    if (panel){ panel.hidden = false; var inp = panel.querySelector('.dante-bis__email'); if (inp) inp.focus(); }
  }
  function subscribe(el){
    var panel = el.querySelector('.dante-bis__panel'); if (!panel) return;
    var inp = panel.querySelector('.dante-bis__email');
    var btn = panel.querySelector('.dante-bis__submit');
    var msg = panel.querySelector('.dante-bis__msg');
    var email = (inp && inp.value || '').trim();
    function show(t, ok){ if (msg){ msg.hidden=false; msg.textContent=t; msg.setAttribute('data-ok', ok?'1':'0'); } }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ show('Escribe un correo válido.', false); if (inp) inp.focus(); return; }
    var company = el.getAttribute('data-company');
    var variantId = el.getAttribute('data-variant') || currentVariant(el);
    if (!company || !variantId){ show('No pudimos registrarte. Intenta de nuevo.', false); return; }
    btn.disabled = true; btn.textContent = 'Enviando...';
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'revision':REV },
      body: JSON.stringify({ data:{ type:'back-in-stock-subscription', attributes:{ channels:['EMAIL'], profile:{ data:{ type:'profile', attributes:{ email: email } } } }, relationships:{ variant:{ data:{ type:'catalog-variant', id:'$shopify:::$default:::' + variantId } } } } })
    }).then(function(r){
      if (r.status === 200 || r.status === 201 || r.status === 202){
        var row = panel.querySelector('.dante-bis__row'); if (row) row.hidden = true;
        var hint = panel.querySelector('.dante-bis__hint'); if (hint) hint.hidden = true;
        show('¡Listo! Te avisaremos apenas vuelva tu talla.', true);
      } else {
        show('No pudimos registrarte. Intenta de nuevo.', false);
        btn.disabled = false; btn.textContent = 'Avisarme';
      }
    }).catch(function(){
      show('No pudimos registrarte. Intenta de nuevo.', false);
      btn.disabled = false; btn.textContent = 'Avisarme';
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('.dante-bis__trigger, .dante-bis__submit') : null;
    if (t){
      var el = t.closest('dante-bis.dante-bis'); if (!el) return;
      e.preventDefault();
      if (t.classList.contains('dante-bis__trigger')) openPanel(el); else subscribe(el);
      return;
    }
    schedule();
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var inp = e.target.closest ? e.target.closest('.dante-bis__email') : null;
    if (!inp) return;
    e.preventDefault();
    var el = inp.closest('dante-bis.dante-bis'); if (el) subscribe(el);
  });

  var deb;
  function schedule(){ clearTimeout(deb); deb = setTimeout(evalAll, 180); }
  document.addEventListener('change', schedule, true);
  window.addEventListener('popstate', schedule);
  if (window.MutationObserver){
    try { new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true }); } catch(e){}
  }
  if (document.readyState !== 'loading') schedule();
  document.addEventListener('DOMContentLoaded', schedule);
})();
